import {
  Directive,
  HostListener,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";

declare var dataLayer;
@Directive({
    selector: "[appDebounceClickGeneral]",
    standalone: false
})
export class DebounceClickGeneralDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 0;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.subscription = this.clicks
      .pipe(debounceTime(this.debounceTime))
      .subscribe((e: any) => {
        this.debounceClick.emit(e);
      });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  @HostListener("click", ["$event"])
  clickEvent(e) {
    let events = e.currentTarget.dataset;
    let data = JSON.parse(JSON.stringify(events));
    dataLayer.push(data);
    /*Object.keys(data).map(key=>{
    });*/
  }
}
